import { Chip, SxProps, Theme, Typography } from "@mui/material";
import theme from "@/config/mui/theme";

export type CardChipProps = {
  label: string;
  textColor: string;
  backgroundColor: string;
  size?: "small" | "medium";
  sx?: SxProps<Theme>;
};

export default function CardChip({
  label,
  textColor,
  backgroundColor,
  size = "small",
  sx,
}: CardChipProps) {
  return (
    <Chip
      label={
        <Typography
          variant={size === "small" ? "labelTiny" : "labelSmall"}
          sx={{
            color: textColor,
          }}
        >
          {label}
        </Typography>
      }
      sx={{
        backgroundColor: backgroundColor,
        height: theme.typography.labelTiny.lineHeight,
        "& .MuiChip-label": {
          px: 1,
        },
        ...sx,
      }}
    />
  );
}
